module.exports = __webpack_public_path__ + "static/lead-news-0-aecfefd942286563a8bd46e600d1cba7.jpg";